import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/layout/Layout';
import { useWallet } from '../context/WalletContext';
import { useReferral } from '../hooks/useReferral';
import WalletModal from '../components/wallet/WalletModal';

const Feature = ({ title, body, color }) => (
  <div className={`card ${color === 'yellow' ? 'card-yellow' : 'card-green'}`}>
    <div className="card-title">{title}</div>
    <div style={{ marginTop: 8, color: 'var(--text-primary)', fontSize: 14 }}>{body}</div>
  </div>
);

const Home = () => {
  const { account } = useWallet();
  const [open, setOpen] = useState(false);
  const { ref } = useReferral();          // captures + persists ?ref= from URL

  return (
    <Layout>
      <section className="hero">
        <h1>Decentralized <span className="accent">Income</span>.<br />Redefined.</h1>
        <p>
          A 7-package, 5-stream income system on opBNB.
          Activate, refer, and earn through Sponsor, Level, Booster, Elite, Pro & Global Royalty pools — all on-chain.
        </p>

        {ref && (
          <div className="badge badge-yellow" style={{ marginBottom: 16 }}>
            Sponsor #{ref} detected
          </div>
        )}

        <div className="hero-cta">
          {account ? (
            <Link to="/dashboard" className="btn btn-primary btn-lg">Open Dashboard</Link>
          ) : (
            <button className="btn btn-primary btn-lg" onClick={() => setOpen(true)}>Connect Wallet</button>
          )}
          <Link to="/register" className="btn btn-outline btn-lg">Register</Link>
        </div>
      </section>

      <section className="section">
        <div className="section-title">Why GalaxyXon</div>
        <div className="grid grid-3">
          <Feature
            color="yellow"
            title="6 Income Streams"
            body="Sponsor 50% · Level 30% (15 levels) · Booster 10% · Elite 3% · Pro 3% · Global 4%."
          />
          <Feature
            color="green"
            title="Direct-Pay Model"
            body="Sponsor / Level / Booster income is paid directly to your wallet on every upgrade — no withdraw needed."
          />
          <Feature
            color="yellow"
            title="4× Ceiling"
            body="Each package earns up to 4× the activation amount. Re-topup to extend your ceiling and continue earning."
          />
          <Feature
            color="green"
            title="2-Leg Matrix"
            body="Per-sponsor 2-leg tree with cursor-based spillover — new joiners are placed under the next available position."
          />
          <Feature
            color="yellow"
            title="Royalty Pools"
            body="Eligible users share in Elite (Pkg 4+), Pro (Pkg 7) and Global (Pkg 7) royalty rounds, weighted by package."
          />
          <Feature
            color="green"
            title="Held Income Protection"
            body="Sponsor income held for 5 days when the upline isn't yet on the package — claim after upgrading."
          />
        </div>
      </section>

      <WalletModal open={open} onClose={() => setOpen(false)} />
    </Layout>
  );
};

export default Home;
